import { render, staticRenderFns } from "./401.vue?vue&type=template&id=099c4504&scoped=true"
import script from "./401.vue?vue&type=script&lang=js"
export * from "./401.vue?vue&type=script&lang=js"
import style0 from "./401.vue?vue&type=style&index=0&id=099c4504&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099c4504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099c4504')) {
      api.createRecord('099c4504', component.options)
    } else {
      api.reload('099c4504', component.options)
    }
    module.hot.accept("./401.vue?vue&type=template&id=099c4504&scoped=true", function () {
      api.rerender('099c4504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error/401.vue"
export default component.exports